import { toast } from 'react-toastify';
import axiosInstance from 'utils/InstanceAxios/InstanceAxios';
import { Types } from '../reducers/session';
import * as serverRoutes from 'utils/consts/serverRoutes.js';
import { axiosInstanceRefresh } from 'utils/InstanceAxios/InstanceAxios';
import axiosRetry from 'axios-retry';
import _ from 'lodash';
axiosRetry(axiosInstanceRefresh, {
  retries: 6,
  retryDelay: () => 10000,
  retryCondition: (_error) => {
    let message = (_error.response?.data || _error.message);
    console.log(_error, message);
    if (message === "Usuário desconectado.") {
      return false;
    }
    return true;
  }
});

const errorMessages = {
  "Network Error": "Erro de conexão com o servidor",
  "Invalid Credentials": "Usuário ou senha incorretos.",
  "Login Access Error": "Erro no acesso do usuário",
  "User account disabled": "Conta de usuário desativada",
  "Token Invalid": "Tempo de acesso esgotado.\nPor favor, logue-se novamente.",
  "Usuário desconectado.": "Tempo de acesso esgotado.\nPor favor, logue-se novamente.",
  "Invalid Token": "Token Inválido. Tente novamente.",
};

//Synchronous

//Asynchronous
export const initLoginLDAP = (username, password, callback) => {
  return dispatch => {
    axiosInstance.post(serverRoutes.Session('/agent'), { username, password })
      .then(response => {
        const { user } = response.data;

        dispatch({
          type: Types.LOGIN,
          payload: user,
        });
        callback(user);
      })
      .catch((err) => {
        let message = (err.response?.data?.error || err.response?.data || err.message);
        message = errorMessages[message] || message;
        callback();
        toast.error(message, { autoClose: 10000 });
      })
  }
}

export const initLogin = (username, password, callback) => {
  return () => {
    axiosInstance.post(serverRoutes.Session(), { username, password })
      .then(() => {
        callback(true);
      })
      .catch((err) => {
        let message = (err.response?.data?.error || err.response?.data || err.message);
        message = errorMessages[message] || message;
        let loginErrorType;
        if (!_.isString(message)) {
          loginErrorType = message.data;
          message = errorMessages[message.message];
        }
        callback(false, loginErrorType);
        if (!loginErrorType?.expiredAccount && loginErrorType?.active !== false) {
          toast.error(message, { autoClose: 10000 });
        }
      })
  }
}

export const initLogin2FA = (username, password, token, callback) => {
  return (dispatch) => {
    axiosInstance.post(serverRoutes.Session('/token'), { username, password, token })
      .then((response) => {
        const { user } = response.data;

        dispatch({
          type: Types.LOGIN,
          payload: user,
        });
        callback(user);
      })
      .catch((err) => {
        let message = (err.response?.data?.error || err.response?.data || err.message);
        message = errorMessages[message] || message;
        callback();
        toast.error(message, { autoClose: 10000 });
      })
  }
}

export const refreshToken = (callback) => {
  return (dispatch, getState) => {
    const { session } = getState();
    axiosInstanceRefresh.post(serverRoutes.Session('/refresh'))
      .then((response) => {
        // Se não houver usuário, captura as informações do mesmo.
        if (session && !session.currentUser) {
          verifySession()(dispatch);
        }
        callback?.();
      })
      .catch((err) => {
        console.log(err)
        let message = (err.response?.data?.error || err.response?.data || err.message);
        message = errorMessages[message] || message;
        if (message === "Token Invalid") {
          initLogout()(dispatch);
        }
        toast.error(message, { autoClose: 10000 });
      })
  }
}

export const verifySession = () => {
  return (dispatch) => {
    dispatch({ type: Types.SET_LOADING });
    axiosInstance.get(serverRoutes.Session())
      .then((response) => {
        dispatch({
          type: Types.VERIFY_SESSION,
          payload: response.data,
        });
      })
      .catch((err) => {
        console.log(err)
        let message = (err.response?.data?.error || err.response?.data || err.message);
        message = errorMessages[message] || message;
        if (message === "Usuário desconectado.") {
          return initLogout()(dispatch);
        }
        return dispatch({
          type: Types.VERIFY_SESSION,
          payload: null,
        });
      })
  }
}

export const initLogout = () => {
  return dispatch => {
    dispatch({ type: Types.LOGOUT });
    axiosInstance.delete(serverRoutes.Session());
  }
}

export const saveCloseTabTime = (username, time) => {
  return () => {
    axiosInstance.post('/sessions/save-close-tab-time', { username, time })
      .catch((err) => {
        console.log(err)
      })
  }
}
